import type { AxiosPromise } from 'axios';
import BaseClient from './BaseClient';
import type { ActiveTermResponse, OrgUnitActiveTermResponse, TermsClientInterface } from './termsClient.types';

class TermsClient extends BaseClient implements TermsClientInterface {
    getActiveTerm(teamId: number, groupId: string): AxiosPromise<ActiveTermResponse> {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/terms/active`;
        return this.makeCoreApiRequest(url, 'get');
    }

    acceptTerm(teamId: number, groupId: string, termId: number): AxiosPromise<void> {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/terms/${termId}/accept`;
        return this.makeCoreApiRequest(url, 'post');
    }

    getOrgUnitActiveTerm(teamId: number, orgUnitId: number): AxiosPromise<OrgUnitActiveTermResponse> {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/terms/active`;
        return this.makeCoreApiRequest(url, 'get');
    }

    acceptOrgUnitTerm(teamId: number, orgUnitId: number, termId: number): AxiosPromise<void> {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/terms/${termId}/accept`;
        return this.makeCoreApiRequest(url, 'post');
    }
}

export default new TermsClient();
